import type {} from "@lit/react";
import { FormRow as FormRowElement, } from "@vaadin/form-layout/vaadin-form-row.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { FormRowElement, };
export type FormRowEventMap = Readonly<{}>;
const events = {} as FormRowEventMap;
export type FormRowProps = WebComponentProps<FormRowElement, FormRowEventMap>;
export const FormRow = createComponent({
    elementClass: FormRowElement, events, react: React, tagName: "vaadin-form-row"
});
